import React from "react";
import { Route, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import Loader from "../components/loader";

const toastOptions = {
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

const AdminOrDutyAdminRoute = ({ component, ...args }) => {
  const { user } = useAuth0();
  const userRoles = user && user["https://new.evojets.com/roles"];
  const isDutyAdminAdmin = user && user["https://new.evojets.com/appMetadata"]?.isDutyAdmin;

  const superAdmin =
    user &&
    userRoles.some(function (role) {
      return "Super Admin" === role;
    });

  if (superAdmin || isDutyAdminAdmin) {
    return (
      <Route
        component={withAuthenticationRequired(component, {
          onRedirecting: () => <Loader/>,
        })}
        {...args}
      />
    );
  }

  toast.error("Unauthorized!", toastOptions);
  return <Redirect to="/"/>;
};

export default AdminOrDutyAdminRoute;
